module.exports = __webpack_public_path__ + "static/img/SJCFLogo.410e8e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/SJCFLogo.png
// module id = ysdM
// module chunks = 0